// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"856":"37fe7616","952":"355437f1"}[chunkId] + ".chunk.js";
};